import './LogoBar.css';
import WelcomeName from '../WelcomeName';
import { NavLink } from 'react-router-dom';
import HomeSharpIcon from '@mui/icons-material/HomeSharp';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

function Searchnav() {
    return (        
        <div className='logo-bar-container'>
            <div className='container'>
                <div className='header d-flex spaceBetween'>
                    <div className='brandLogo d-flex'>
                        <div className='brandImage'>
                            <img src={process.env.PUBLIC_URL + '/images/accenture-logo.png'} alt="accenture-Log-Img" className='accenture-logo-img img-responsive'/>                            
                        </div>  
                        <div className='titleSection'>                   
                        <div className='header-title'>                            
                            <span className='header-title-1 desktop-tag'>Learning and Knowledge Management</span>
                            <p class="header-title-1 mobile-tag">LKM</p>
                            {/* <span className='header-title-2'>E&IT Academy</span>*/}
                            <span className='header-title-2'>Enterprise Platforms</span>                         
                            
                        </div>
                        <div className='sap_home_icon'>                            
                            {/* <NavLink to="/"> <HomeSharpIcon fontSize="large" sx={{ color: 'black' }}/> </NavLink> */}
                            <NavLink to="/"> <HomeSharpIcon/> </NavLink>
                        </div>
                    </div>   
                    </div>
                    <div className='user-detail'>                        
                        {/* <AccountCircleIcon sx={{ fontSize: 45 }} className='avatar-img'/>*/}
                        <img src="/images/Avatar.png" class="user-img" alt="user-image" />
                        <WelcomeName />
                    </div>
                </div>
                </div>
                </div>                       
    )
}

export default Searchnav
